export enum responseCodes {
  ok = '200',
  badRequest = '400',
}
